import { useEffect, useState } from 'react';
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import logo from "../../../studentassets/logo.png";
import { useDispatch, useSelector } from 'react-redux';
import { toggleMode, selectMode } from '../../../service/slice/ThemeSlice';
import { MdOutlineLightMode } from "react-icons/md";
import { MdOutlineDarkMode } from "react-icons/md";
import img1 from "../../../adminassets/img/background.png";
import { setPageLoading, setUser, userDetails, userLoading } from '../../../service/slice/AuthSlice';


export default function AdminSignin() {

    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [showPassword, setShowPassword] = useState(false);
    const user = useSelector((state) => state.userSlice?.value);
    const theme = useSelector(selectMode);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            navigate("/admin");
        }
    }, [navigate])

    const themeColor = {
        color: theme === 'light' ? '#000' : '#fff',
        background: theme === 'light' ? '#fff' : '#151A24'
    };


    function validateEmail(email) {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    }

    function isValidPhoneNumber(phone) {
        const regex = /^\d{10}$/;
        return regex.test(phone);
    }

    function validatePassword(password) {
        const re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        return re.test(password);
    };

    const handleSubmit = async (event) => {
        if (event) event.preventDefault();

        if (validateEmail(email) && isValidPhoneNumber(email)) {
            toast.error("Please enter valid email or phone number.");
            return;
        }

        const loginData = {
            email: email,
            password: password,
        }

        if (!validatePassword(password)) {
            toast.info("Password must be at least 8 characters, include uppercase, lowercase, number, and special character!");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/login`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(loginData),
            });
            const data = await response.json();

            if (data.status === true) {
                toast.success("Signin successful!");
                localStorage.setItem("authAdminToken", data.token);

                dispatch(setUser({ userDetails: data.userDetails }));
                dispatch(setPageLoading({ pageLoading: false }));
                navigate('/admin');

            } else {
                toast.error("Invalid Email ID or password!");
                navigate("/adminSignin");
            }

            // Clear fields on success
            setEmail('');
            setPassword('');

        } catch (error) {
            toast.error("An error occurred. Please try again later.");
        }
    }


    return (
        <>
            {/* Navbar */}
            <nav className="navbar navbar-expand-lg navbar-light bg-white py-2 fixed-top" style={{ ...themeColor, height: "80px" }}>
                <div className="container-fluid">
                    {/* Logo */}
                    <Link to="/" className="navbar-brand">
                        <img src={logo} alt="Logo" style={{ width: '96px', marginTop: "0.4em" }} />
                    </Link>

                    {/* Right Side */}
                    <div className="d-flex align-items-center gap-3 d-none d-md-flex">

                        <button className="theme-toggle-btn" onClick={() => dispatch(toggleMode())} style={themeColor}>
                            {theme === "light" ? <MdOutlineLightMode /> : <MdOutlineDarkMode />}
                        </button>

                    </div>
                </div>
            </nav>


            {/* Toast container */}
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            <div className="">
                <div className="row vh-100">

                    <div className="col-12 col-md-6 p-0 ms-0">
                        <img src={img1} alt="img" className="img-fluid w-100 h-100" style={{ objectFit: "cover" }} />
                    </div>


                    <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
                        <form onSubmit={(event) => handleSubmit(event)} className="w-75">

                            <h2 className="mb-4 text-center">Admin Sign In</h2>

                            <div className="mb-3">
                                <label className="form-label">Email</label>
                                <input
                                    className="form-control form-control-lg"
                                    type="text"
                                    value={email}
                                    onChange={(event) => setEmail(event.target.value)}
                                    placeholder="Email"
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label htmlFor="password" className="form-label">Password</label>
                                <div className="d-flex align-items-center position-relative">
                                    <input
                                        className="form-control form-control-lg pe-5"
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        onChange={(event) => setPassword(event.target.value)}
                                        placeholder="Password"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="position-absolute end-0 me-2 p-0 w-20 fs-5 bg-transparent border-0"
                                    >
                                        {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                                    </button>
                                </div>
                            </div>

                            <div className="d-flex justify-content-end mb-3">
                                <Link to="/adminForgot">Forgot password?</Link>
                            </div>

                            <div className="d-grid">
                                <button type="submit" className="btn btn-primary btn-lg">
                                    Sign in
                                </button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </>
    )
}
